import React, { FC } from "react";
import { ICellRendererParams } from "ag-grid-community";
import HistoryList from "components/portfolio/cellRenderer/AnchorProductRenderer/HistoryList";
import AnchorEditor from "components/portfolio/cellRenderer/AnchorProductRenderer/AnchorEditor";
import { classHOC } from "components/app/ClassWrapper";

const Index: FC<
  Partial<ICellRendererParams> & {
    minWidth?: number;
  }
> = ({ node, data, value, api, minWidth, columnApi, column }) => {
  if (node?.rowPinned) return null;

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        height: "100%",
      }}
    >
      <HistoryList accountKey={data?.accountKey} />
      <AnchorEditor
        data={data}
        node={node}
        value={value}
        api={api}
        columnApi={columnApi}
        minWidth={minWidth}
        column={column}
      />
    </div>
  );
};

export default classHOC(Index);
